import { render, staticRenderFns } from "./LernerFeatured.vue?vue&type=template&id=2bdeaa15&scoped=true&"
import script from "./LernerFeatured.vue?vue&type=script&lang=js&"
export * from "./LernerFeatured.vue?vue&type=script&lang=js&"
import style0 from "./LernerFeatured.vue?vue&type=style&index=0&id=2bdeaa15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdeaa15",
  null
  
)

export default component.exports